import { useEffect, useState } from 'react'
import { teachersStore } from '../services/teachersStore'

export function useTeachers() {
  const [teachers, setTeachers] = useState(teachersStore.getAll())

  useEffect(
    () => teachersStore.subscribe(() => setTeachers(teachersStore.getAll())),
    [],
  )

  return teachers
}
